import React from 'react'
import { Routes, Route } from 'react-router-dom'

import CV from './CV'
import Art from './3d'
import Dev from './Dev'
import Nav from './Nav'

function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path='/' element={<CV />} />
        <Route path='/3D' element={<Art />} />
        <Route path='/Dev' element={<Dev />} />
      </Routes>
    </>
  )
}

export default App
